<template>
  <!-- Sidebar -->

  <v-card class="sidebar-menu">
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      permanent
      disable-resize-watcher
    >
      <v-list-item class="p-0 mb-5"> 
        <router-link to="/main/home" >
           <img ref="logo" class="sidebar-logo mt-5 ml-2" :src="logoSrc" />
        </router-link>
        <v-btn
          color="white"
          icon
         @click.stop="toggleMini"
        >
        <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-list>
        <router-link to="/main/home">
          <v-list-item>
            <v-list-item-icon>
              <i class="fas fa-fw fa-home"></i>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>ANA SAYFA</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>

          <router-link to="/pages/ads">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-edit"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>İLANLAR</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/occupations">
            <v-list-item>
              <v-list-item-icon>
               <i class="fas fa-id-card"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>MESLEKLER</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/users">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-users"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>KULLANICILAR</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/contentManagement">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-tasks"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>İÇERİK YÖNETİMİ</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/adUsers">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-user-friends"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>İLAN KULLANICILARI</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/pages/generalSettings">
            <v-list-item>
              <v-list-item-icon>
                <i class="fas fa-cogs"></i>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>GENEL AYARLAR</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>


      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>


<script>
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class SideBarMenu extends Vue {
  data() {
    return {
     drawer: true,
      mini: false
    };
  }

 get logoSrc() {
      return this.mini ? require("../images/mini_logo.png") : require("../images/logo.png");
    }
toggleMini() {
      this.mini = !this.mini;
    }






}
</script>

<style scoped>
.sidebar-logo {
  width: 80%;
}

::v-deep .theme--light.v-navigation-drawer {

 background-image: linear-gradient(
  45deg,
  hsl(267deg 100% 7%) 0%,
  hsl(292deg 67% 14%) 10%,
  hsl(317deg 97% 20%) 12%,
  hsl(331deg 100% 29%) 14%,
  hsl(342deg 100% 37%) 15%,
  hsl(13deg 78% 46%) 16%,
  hsl(38deg 73% 43%) 17%,
  hsl(64deg 36% 53%) 18%,
  hsl(116deg 37% 75%) 19%,
  hsl(162deg 62% 88%) 20%,
  hsl(182deg 61% 86%) 21%,
  hsl(193deg 70% 68%) 22%,
  hsl(195deg 100% 45%) 24%,
  hsl(205deg 100% 43%) 26%,
  hsl(217deg 95% 40%) 29%,
  hsl(228deg 67% 38%) 33%,
  hsl(225deg 71% 28%) 37%,
  hsl(224deg 67% 20%) 44%,
  hsl(226deg 55% 13%) 53%,
  hsl(236deg 70% 4%) 74%
);

}

.v-sheet.v-card {
  border-radius: 0px;
}

.v-list-item .v-list-item__title {
  line-height: 1.2;
  color: white;
  font-size: 14px;
}

.v-list-item__icon:first-child {
  margin-right: 20px !important;
  font-size: 18px;
  color: white;
}

::v-deep
  .v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon
  i {
  color: white;
}

a:hover {
  text-decoration: none !important;
}

@media only screen and (max-width: 992px) {
  .sidebar-menu {
    display: none;
  }
}
</style>
